<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>The author was born, raised and currently lives in the West Midlands. After studying psychology and having a keen interest in family history and ancestry, she enjoys delving into people’s backstories, researching and bringing them to life.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?9126c550